// import React from 'react'

// const SalesStockIn = () => {
//   return (
//     <div>SalesStockIn</div>
//   )
// }

// export default SalesStockIn

import React, { useState, useEffect } from "react";
// import CustomTable from "../../../../customComponents/CustomTable";
// import './index.scss';
// import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
// import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../../../services/api/API";
// import ROUTES_NAVIGATION from "../../../../../routes/routes";
// import searchIcon from "../../../../../Assets/icons/searchicon.svg";
// import Loader from "../../../../customComponents/CustomLoader";
// import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
// import ProductTable from './ProductTable';
import { FiDownload } from "react-icons/fi";
// import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import CustomTable from "../../../customComponents/CustomTable";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../customComponents/CustomLoader";
import axiosInstance from "../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../routes/routes";

import viewIcon from "./../../../../Assets/icons/eye 1.svg";
import editIcon from "./../../../../Assets/icons/Un-Checkbox.svg";
import download from "./../../../../Assets/icons/download.svg";

import * as base64 from "base-64";

const SalesStockIn = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [filters, setFilters] = useState({});
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
   const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const fetchVariantList = async (page = 0, pageSize = 10) => {
    try {
      const allfilteredData = filters;
      setLoading(true);
      const response = await axiosInstance.post(
        "/purchaseorder/existingacceptlist",
        {
          orderBy: "po_id desc",
          page,
          pageSize,
          searchText: searchTerm,
          // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
          // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
           dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        po_type: item.po_type || "- -",
        po_delivery_date: item.po_delivery_date || "--",
        po_expected_date: item.po_expected_date || "--",
        approval_remark: item.approval_remark || "--",
        created_by_name: item.created_by_name || "--",
        updated_by_name: item.updated_by_name || "--",
        // status: item.status === "View VIN" ? "Received" : item.status,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.countdata;
      console.log(response, totalCount, "totalCount");
      setTotalData(totalCount);
      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching variant list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductData = async () => {
    const allfilteredData = filters;
    const payload = {
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };
    console.log("filteresdata", payload);

    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchVariantList(newPage);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post(
        "/product/product-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "product.csv";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const VARIANT_TABLE_HEADERS = [
    "Dealer Name",
    "PO No.",
    "PO Date",
    //"PO Type",
    "Order Quantity",
    // "Modified Quantity",
    // "Accepted",
    // "Defective",
    // "Created By",
    // "Role",
    // "Updated By",
    // "Dealer Expected Date",
    // "Revised Expected Date",
    "Total Price",
    "Status",
    // "Remark",
    "Action",
  ];

  const variantKeyMapping = {
    "Dealer Name": "dealer_name",
    "PO No.": "po_number",
    "Stock Date": "po_date",
    Role: "role_name",
    // "PO Type":"po_type",
    "Order Quantity": "orderqty",
    "Modified Quantity": "accepted_qty",
    // "Defective":"defective_qty",
    Status: "status",
    "Dealer Expected Date": "po_dealer_expected_date",
    "Revised Expected Date": "po_delivery_date",
    "Created By": "created_by_name",
    "Updated By": "updated_by_name",
    Remark: "remark",
    "Total Price": "total",
    Action: [
      { type: "view", icon: viewIcon, label: "view" },
      // { type: "draftedit", icon: editIcon, label: "Edit" },
      // {
      //   type: "manageorder",
      //   icon: download,
      //   label: "Print",
      // },
    ],
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchVariantList();
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.ADDSTOCKINSALES}`, {
      state: { data: rowData },
    });
  };

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    },
    // {
    //   name: "fromDate",
    //   label: "From Date",
    //   type: "date",
    //   maxDate: new Date(),
    //   // required: true,
    //   gridClass: "col-lg-3",
    // },
    // {
    //   name: "toDate",
    //   label: "To Date",
    //   type: "date",
    //   maxDate: new Date(),
    //   // required: true,
    //   gridClass: "col-lg-3",
    // },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
      dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
      colorId: filterFormData?.colorId || null,
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    // fetchJobCardList();
  };

  useEffect(() => {
    fetchVariantList();
  }, [filters]);

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const DownLoadPdf = async (row) => {
    try {
      var text = row?.po_id;
      var encoded = base64.encode(text);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}dealer/dealer-wise-inovice/${encoded}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // if needed
          },
        },
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `dealer_invoice_${row?.po_id}.pdf`; // file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const handleView = (rowData) => {
    console.log("rowdata>", rowData);
    if (
      rowData.status === "In Transit" ||
      rowData.status === "Partially Received " ||
      rowData.status === "Partial Delivered" ||
      rowData.status === "Received with Damaged Items Accepted"
    ) {
      navigate(ROUTES_NAVIGATION.INTRANSIT, {
        state: { data: rowData },
      });
    } else {
      navigate(ROUTES_NAVIGATION.MANAGEORDERDETAILS, {
        state: { data: rowData },
      });
    }
  };

  const onEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITGENERATEORDER}`, {
      state: { data: rowData },
    });
  };

    useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer">
                <h5>Stock-In Management</h5>
              </div>
              <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
                {/* <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalData} </h5>
                  <h6>All Product</h6>
                </div>
                <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                  <h5 className="listTopDataValueText" >{totalActive} </h5>
                  <h6>Active Product</h6>
                </div>
                <div className='topleftdataContainer'>
                  <h5 className="listTopDataValueText" >{totalInactive} </h5>
                  <h6>Inactive Product</h6>
                </div> */}
                <button
                  className="addcustomerbutton"
                  onClick={() =>
                    navigate("/sales/manage-product/stock-in/add-stock-in")
                  }
                >
                  Add Stock In
                </button>
              </div>
            </div>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h5>Stock-In List</h5>
                  {/* <div>
                    <SearchInput
                      placeholder="Search Item"
                      onSearch={fetchVariantList}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div> */}
                  {/* <div
                    onClick={downloadExcel}
                    className="flte-btnnn"
                    style={{ borderRadius: "38px", cursor: "pointer" }}
                  >
                    Export
                    <span>
                      <FiDownload
                        className="downloadexcel-misreportsales"
                        style={{ cursor: "pointer" }}
                        size={22}
                      />
                    </span>
                  </div> */}
                </div>
              </div>
              <CustomTable
                data={productData}
                headers={VARIANT_TABLE_HEADERS}
                keyMapping={variantKeyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                handleViewButton={handleView}
                totalRecords={totalRecords}
                onEdit={onEdit}
                pdfDownLoad={DownLoadPdf}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SalesStockIn;
